import React from "react";

const NewVersion = ({style = {}, size = "36", className = "", fill = "#FFA700", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          d="M18.615 6.661h-1.23V2h1.23v4.661zm-9.71 3.863L5.378 7.191l.874-.827 3.52 3.338-.867.822zM34 17.731v1.165h-4.855v-1.165H34zm-32 0h5.046v1.165H2v-1.165zm28.622-10.54l-3.323 3.14-.868-.82 3.317-3.147.873.827z"
          fill="#60B158"
      />
      <path
          d="M18.23 8.41c-2.447 0-4.795.92-6.526 2.559C9.973 12.608 9 14.83 9 17.149c0 2.179 1.982 5.278 2.461 5.995v4.492c0 .678.251 1.335.709 1.858a3.115 3.115 0 001.796 1.003 4.023 4.023 0 001.442 2.505A4.452 4.452 0 0018.23 34c1.037 0 2.04-.354 2.823-.998a4.023 4.023 0 001.441-2.505 3.116 3.116 0 001.797-1.003A2.82 2.82 0 0025 27.636v-4.492c.48-.717 2.462-3.816 2.462-5.995 0-2.318-.973-4.541-2.704-6.18-1.731-1.64-4.08-2.56-6.527-2.56zm0 24.47c-.709 0-1.396-.232-1.946-.657a2.891 2.891 0 01-1.069-1.674h6.031a2.891 2.891 0 01-1.069 1.674 3.186 3.186 0 01-1.946.657z"
          fill={fill}
      />
      <mask
          id="prefix__a"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x={9}
          y={8}
          width={19}
          height={26}
      >
        <path
            d="M18.23 8.41c-2.447 0-4.795.92-6.526 2.559C9.973 12.608 9 14.83 9 17.149c0 2.179 1.982 5.278 2.461 5.995v4.492c0 .678.251 1.335.709 1.858a3.115 3.115 0 001.796 1.003 4.023 4.023 0 001.442 2.505A4.452 4.452 0 0018.23 34c1.037 0 2.04-.354 2.823-.998a4.023 4.023 0 001.441-2.505 3.116 3.116 0 001.797-1.003A2.82 2.82 0 0025 27.636v-4.492c.48-.717 2.462-3.816 2.462-5.995 0-2.318-.973-4.541-2.704-6.18-1.731-1.64-4.08-2.56-6.527-2.56zm0 24.47c-.709 0-1.396-.232-1.946-.657a2.891 2.891 0 01-1.069-1.674h6.031a2.891 2.891 0 01-1.069 1.674 3.186 3.186 0 01-1.946.657z"
            fill={fill}
        />
      </mask>
      <g mask="url(#prefix__a)" fill="#fff">
        <circle opacity={0.15} cx={26} cy={20} r={3} />
        <circle opacity={0.15} cx={10} cy={19} r={2} />
        <circle opacity={0.15} cx={18} cy={12} r={1} />
        <circle opacity={0.2} cx={23} cy={27} r={1} />
        <circle opacity={0.2} cx={14.5} cy={25.5} r={0.5} />
      </g>
      <path
          d="M22.352 13.89l-.102-.096-.103.097-4.772 4.492-2.522-2.374-.103-.097-.103.097-.75.705-.116.11.116.109 3.375 3.176.103.097.103-.097 5.625-5.294.116-.11-.116-.108-.75-.706z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={0.3}
      />
    </svg>
);

export default NewVersion;